import { useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";

export default function NoticeFixModal({ show, onClose, onSave, initialData }) {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  // 수정 시 기존 내용 불러오기 / 글쓰기 시 초기화
  useEffect(() => {
    setTitle(initialData?.subject || "");
    setContent(initialData?.content || "");
  }, [initialData]);

  const handleClose = () => {
    modalInstance.current?.hide();
  };

  const handleSave = () => {
    if (!title.trim() || !content.trim()) {
      alert("제목과 내용을 입력해주세요.");
      return;
    }

    onSave({ subject: title, content });
    handleClose();
  };

  useEffect(() => {
    if (!modalRef.current) return;

    if (show) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: true,
      });

      modalInstance.current.show();

      const handleHidden = () => {
        onClose?.();
      };

      modalRef.current.addEventListener("hidden.bs.modal", handleHidden);

      return () => {
        if (modalRef.current) {
          modalRef.current.removeEventListener("hidden.bs.modal", handleHidden);
        }
      };
    }
  }, [show]);

  return (
    <div className="modal fade" id="modalNotiFix" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header input-group">
            <span className="input-group-text">제목</span>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="modal-body input-group">
            <span className="input-group-text">내용</span>
            <textarea
              className="form-control"
              rows="10"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>

          <div className="modal-footer">
            <button className="btn btn-lg btn-info" onClick={handleSave}>
              {initialData ? "수정" : "등록"}
            </button>
            <button className="btn btn-lg btn-gray" onClick={handleClose}>
              취소
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
